<ul class="widget-list" *ngIf="productsArr && productsArr.length">
    <li *ngFor="let item of productsArr">
        <a href="#">{{item}}</a>
    </li>
</ul>